import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import i18n from '../../../i18n';

import HomeModel from '../../../models/Home';

import { AlertDialog } from '@homeexchange/design';
import User from '../../../models/User';
import Analytics from '../../../utils/analytics';
import useGTM from '../../analytics/useGTM';
import { NAVIGATION_ACTION, NAVIGATION_AREAS, NAVIGATION_TEXT } from '../../analytics/analytics-constants';

export default function Success({ showModal, onCloseModal, home, search }) {
    const homeUser = useSelector((state) => state.loadedUsers[home.get('user').get('id')]);
    const { fetchNavigation } = useGTM(homeUser);

    useEffect(() => {
        if (showModal) {
            Analytics.trackGTM(
                'modal',
                fetchNavigation(
                    NAVIGATION_ACTION.VIEW,
                    NAVIGATION_AREAS.CONTACT_MODAL_MESSAGE_SENT,
                    NAVIGATION_TEXT.MESSAGE_SENT
                )
            );
        }
    }, [showModal]);
    return (
        <AlertDialog
            isOpen={showModal}
            title={i18n.t('exchange:modale.exchangeRequest.confirmation.messageSent.title', {
                hostName: homeUser.get('first_name')
            })}
            confirmActionText={i18n.t('exchange:contact.contact_more_members')}
            onConfirmAction={() => {
                Analytics.trackGTM(
                    'button',
                    fetchNavigation(
                        NAVIGATION_ACTION.CLICK,
                        NAVIGATION_AREAS.CONTACT_MODAL_MESSAGE_SENT,
                        NAVIGATION_TEXT.CONTACT_OTHER_MEMBERS
                    ),
                    () => {
                        window.location.href = i18n.t('search:search_url', {
                            slug: search?.place ? encodeURIComponent(search.place) : 'everywhere'
                        });
                    }
                );
            }}
            iconStatus="success"
            calloutProps={
                homeUser.get('reactivity_level') === 'LOW'
                    ? {
                          status: 'warning',
                          size: 'medium',
                          children: i18n.t('exchange:responseRate.calloutDesc.warning', {
                              hostName: homeUser.get('first_name')
                          })
                      }
                    : null
            }
            dismissActionText={i18n.t('common:close')}
            onDismissAction={() => {
                Analytics.trackGTM(
                    'button',
                    fetchNavigation(
                        NAVIGATION_ACTION.CLICK,
                        NAVIGATION_AREAS.CONTACT_MODAL_MESSAGE_SENT,
                        NAVIGATION_TEXT.CLOSE
                    ),
                    () => {
                        onCloseModal();
                    }
                );
            }}
        >
            {i18n.t('exchange:modale.exchangeRequest.confirmation.messageSent.body', {
                hostName: home.get('user').get('first_name')
            })}
        </AlertDialog>
    );
}

Success.propTypes = {
    showModal: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    home: PropTypes.instanceOf(HomeModel).isRequired,
    homeUser: PropTypes.instanceOf(User).isRequired,
    search: PropTypes.shape({
        place: PropTypes.string
    })
};
